// extracted by mini-css-extract-plugin
module.exports = {"mobileAppPromo":"mobileAppPromo_mobileAppPromo__v12Pm","promoButton":"mobileAppPromo_promoButton__fngvm","promoBanner":"mobileAppPromo_promoBanner__kbR31"};